/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function goToCustomise(el) {
  const form = $(el).closest('form[id]');
  const customise_page = $(el).data('href') + '?variant=' + $('[name="id"]', form).val();
  window.location = customise_page;
}

(function() {
  'use strict';

  // Cart badge count: a customised bottle + its print/engraving service is ONE
  // bundle but two Shopify line items, so cart.item_count double-counts it. The
  // service line carries the hidden `_flexidesign` property (see
  // snippets/bl_cart-bundle-role.liquid). Count only NON-service lines, so a bundle
  // = 1 and x2 quantity = 2. The header renders this correctly server-side on first
  // paint (sections/header.liquid); here we keep it in sync because the theme's
  // <cart-count> resets itself to item_count on every cart:updated / cart:refresh.
  function initBundleCartCount() {
    var expected = null; // last known bundle-aware count, as a string

    function countFromCart(cart) {
      if (!cart || !cart.items) return null;
      var n = 0;
      cart.items.forEach(function (it) {
        if (!(it.properties && it.properties['_flexidesign'])) n += it.quantity;
      });
      return String(n);
    }
    function paint() {
      if (expected == null) return;
      document.querySelectorAll('cart-count').forEach(function (el) {
        if (el.textContent !== expected) el.textContent = expected;
      });
    }
    function onCartEvent(e) {
      var v = countFromCart(e && e.detail && e.detail.cart);
      if (v != null) { expected = v; paint(); return; }
      // Event without line items → fetch the full cart, then correct.
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { expected = countFromCart(cart); paint(); })
        .catch(function () {});
    }

    // cart:updated / cart:refresh bubble to documentElement (theme + bl_cart-bundle).
    // Our listeners run AFTER the theme's <cart-count> handler, so they correct it.
    document.documentElement.addEventListener('cart:updated', onCartEvent);
    document.documentElement.addEventListener('cart:refresh', onCartEvent);

    // Seed from the server-rendered badge (already bundle-aware) and enforce it: a
    // late async item_count write by the theme is re-corrected by the observer.
    var seed = document.querySelector('cart-count');
    if (seed) expected = (seed.textContent || '').trim();
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(paint);
      document.querySelectorAll('cart-count').forEach(function (el) {
        mo.observe(el, { childList: true, characterData: true, subtree: true });
      });
    }
  }

  /* ── Device trace → order attributes ─────────────────────────────────────
     Registers the visitor's browser / OS / device model as HIDDEN cart
     attributes (leading "_" keeps them off customer-facing surfaces). Cart
     attributes become the order's note_attributes at checkout, so every order
     can be traced back to the exact device/browser when debugging an issue.
     The raw user-agent is stored too — parsed fields are the quick glance,
     the UA is the full-fidelity source. Never throws: tracing must not break
     the page, and /cart/update.js MERGES attributes so nothing else on the
     cart is touched. */
  function getDeviceDetails() {
    var ua = navigator.userAgent;
    var pick = function (re) { return (ua.match(re) || [])[1] || ''; };

    // Order matters: Chromium Edge/Opera/Samsung UAs all contain "Chrome",
    // and modern Edge identifies as "Edg/" (not "Edge/").
    var browser = 'NA', bVer = '';
    if (ua.indexOf('Firefox') !== -1 && ua.indexOf('Seamonkey') === -1) { browser = 'Firefox'; bVer = pick(/Firefox\/([\d.]+)/); }
    else if (ua.indexOf('SamsungBrowser') !== -1) { browser = 'Samsung Internet'; bVer = pick(/SamsungBrowser\/([\d.]+)/); }
    else if (ua.indexOf('Edg') !== -1)            { browser = 'Microsoft Edge';   bVer = pick(/Edg(?:e|A|iOS)?\/([\d.]+)/); }
    else if (ua.indexOf('OPR') !== -1 || ua.indexOf('Opera') !== -1) { browser = 'Opera'; bVer = pick(/(?:OPR|Opera)\/([\d.]+)/); }
    else if (ua.indexOf('CriOS') !== -1)          { browser = 'Google Chrome (iOS)'; bVer = pick(/CriOS\/([\d.]+)/); }
    else if (ua.indexOf('Chrome') !== -1 && ua.indexOf('Chromium') === -1) { browser = 'Google Chrome'; bVer = pick(/Chrome\/([\d.]+)/); }
    else if (ua.indexOf('Safari') !== -1)         { browser = 'Safari'; bVer = pick(/Version\/([\d.]+)/); }
    else if (ua.indexOf('MSIE') !== -1 || ua.indexOf('Trident/') !== -1) { browser = 'Internet Explorer'; bVer = pick(/(?:MSIE |rv:)([\d.]+)/); }

    var os = 'NA';
    if (ua.indexOf('Android') !== -1)        os = ('Android ' + pick(/Android\s+([\d.]+)/)).trim();
    else if (/iPhone|iPad|iPod/.test(ua))    os = ('iOS ' + pick(/OS (\d+[_\d]*)/).replace(/_/g, '.')).trim();
    else if (ua.indexOf('Windows NT') !== -1) os = 'Windows';
    else if (ua.indexOf('Macintosh') !== -1)  os = 'macOS';
    else if (ua.indexOf('Linux') !== -1)      os = 'Linux';

    // Model: high-entropy client hints are the reliable source on modern
    // Chrome — Android UA-reduction replaces the real model in the UA string
    // with the literal "K", so the UA regex is only a legacy fallback.
    var finish = function (model) {
      if (!model || model === 'K') {
        if (ua.indexOf('iPhone') !== -1)      model = 'iPhone (exact model hidden by iOS)';
        else if (ua.indexOf('iPad') !== -1)   model = 'iPad (exact model hidden by iOS)';
        else if (os.indexOf('Android') === 0) model = pick(/Android\s+[\d.]+;\s+([^;)]+)/).trim() || 'NA';
        else model = 'NA';
        if (model === 'K') model = 'NA';
      }
      return {
        browser: (browser + (bVer ? ' ' + bVer : '')).trim(),
        os: os,
        model: model,
      };
    };

    if (navigator.userAgentData && typeof navigator.userAgentData.getHighEntropyValues === 'function') {
      return navigator.userAgentData.getHighEntropyValues(['model'])
        .then(function (hints) { return finish(hints.model); })
        .catch(function () { return finish(''); });
    }
    return Promise.resolve(finish(''));
  }

  function initDeviceTraceAttributes() {
    getDeviceDetails().then(function (info) {
      var attrs = {
        '_DeviceBrowser': info.browser,
        '_DeviceOS':      info.os,
        '_DeviceModel':   info.model,
        '_DeviceUA':      navigator.userAgent,
      };
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      // Register only when missing/changed: one lightweight GET per page load;
      // the POST then happens once per cart, not on every page view.
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var cur = (cart && cart.attributes) || {};
          var same = Object.keys(attrs).every(function (k) { return cur[k] === attrs[k]; });
          if (same) return;
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs }),
          });
        });
    }).catch(function () { /* tracing must never break the page */ });
  }

  /* ── Orphaned personalisation-bundle cleanup ─────────────────────────────
     A personalisation is a BUNDLE of two lines sharing one id: a bottle line
     carrying an EngravingID / ColorPrintID, and a service line (hidden
     `_flexidesign` marker) carrying the SAME id. The two must live and die
     together — NEITHER half is valid alone:
       • a SERVICE with no matching bottle → billed, nothing to engrave;
       • a BOTTLE still carrying an id with no matching service → a broken
         bundle pointing at a design that was never paid for.
     So we remove BOTH halves of any broken bundle. A PLAIN bottle (no id) is
     valid and never touched; caps/boots carry no id so they're never touched
     either. We can't use a Cart Transform (it collides with 3rd-party discount
     apps), so we sweep on load and on every cart change. Mirrors
     bl_cart-bundle-role.liquid (bottle = shared id WITHOUT _flexidesign;
     service = WITH _flexidesign). */
  var _orphanBusy = false;
  function removeOrphanedBundleLines() {
    if (_orphanBusy) return;                 // also breaks the self-dispatch loop
    _orphanBusy = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var bid = function (it) { return (it.properties && (it.properties.EngravingID || it.properties.ColorPrintID)) || null; };
    var isService = function (it) { return !!(it.properties && it.properties._flexidesign); };
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        // null-proto so ids can't collide with __proto__/constructor/etc.
        var serviceIds = Object.create(null); // ids held by service lines
        var bottleIds  = Object.create(null); // ids held by non-service (bottle) lines
        items.forEach(function (it) {
          var b = bid(it); if (!b) return;
          if (isService(it)) serviceIds[b] = true; else bottleIds[b] = true;
        });
        var updates = {}, any = false;
        items.forEach(function (it) {
          var b = bid(it);
          if (!b) return;                    // plain bottle / cap / boot → always valid, never touched
          // Orphaned when the OTHER half of the bundle is missing:
          //   service line → needs a bottle sharing its id
          //   bottle line  → needs a service sharing its id
          var orphaned = isService(it) ? !bottleIds[b] : !serviceIds[b];
          if (orphaned) { updates[it.key] = 0; any = true; }
        });
        if (!any) return null;
        return fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          // Re-render cart UI + header badge now the broken bundle is gone. The
          // resulting cart:refresh re-enters this fn while _orphanBusy is still
          // true (reset below), so it no-ops — no loop.
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function () { /* cleanup must never break the page */ })
      .then(function () { _orphanBusy = false; });
  }
  function initOrphanBundleCleanup() {
    removeOrphanedBundleLines(); // sweep pre-existing broken bundles on load
    document.documentElement.addEventListener('cart:updated', function () { removeOrphanedBundleLines(); });
    document.documentElement.addEventListener('cart:refresh', function () { removeOrphanedBundleLines(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initBundleCartCount();
    initDeviceTraceAttributes();
    initOrphanBundleCleanup();
  });
})();